<template>
  <path d="M6 6L12 -9.53991e-08L-5.24537e-07 9.53674e-07L6 6Z" fill="#069EE0" />
</template>
